import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <p className="text-xs font-semibold text-primary-600 uppercase tracking-widest mb-3">What Is It</p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-900 mb-6">
              What Is <span className="text-primary-500">Basetao Spreadsheet</span>?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                A <strong>Basetao spreadsheet</strong> is a curated database of product finds organized by category, making it easy to discover and compare items available through the Basetao shopping agent platform. Instead of browsing endless product pages, you get a structured, searchable collection of the best finds across fashion, sneakers, accessories, and more.
              </p>
              <p>
                Think of it as your personal shopping assistant &mdash; someone has already done the hard work of finding quality products, organizing them by type, and presenting them in an easy-to-navigate format. Whether you are hunting for the latest sneaker releases, streetwear essentials, or unique accessories, a Basetao spreadsheet streamlines the entire discovery process.
              </p>
              <p>
                The spreadsheet format allows for <strong>quick price comparisons</strong>, <strong>category filtering</strong>, and <strong>direct links</strong> to product pages, saving you hours of manual searching and helping you make smarter purchasing decisions.
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/article/basetao-spreadsheet-guide"
                className="px-5 py-2.5 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-900 rounded-lg border border-background-300/60 hover:border-background-400 transition-colors whitespace-nowrap"
              >
                Visit Main Website
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20clean%20wooden%20desk%20showing%20fashion%20shopping%20website%20with%20product%20grid%2C%20warm%20natural%20window%20light%2C%20cozy%20minimalist%20workspace%2C%20coffee%20cup%20and%20notebook%20nearby%2C%20lifestyle%20editorial%20photography%2C%20soft%20warm%20beige%20tones&width=800&height=600&seq=whatis-v2-2026-b2&orientation=landscape"
                alt="Basetao spreadsheet displayed on a modern laptop workspace"
                title="Basetao Spreadsheet product discovery platform"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}